import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getAddMemberShareLink, getMyGroupMembers } from '../../api/playerGroupApi';
import { getApiAxiosInstance } from '../../utils/network';
import { showErrorPopup } from '../../actions/notification-actions';
import requireAuth from '../../components/hocs/requireAuth';
import styles from './playerGroups.scss';
import ShareUrlPopupNew from '../../components/PopUps/ShareUrlPopup';
import PlayersListSortable from '../../components/Players/PlayersListSortable';

const MyGroupsPage = (props) => {
    const [memberResults, setMemberResults] = useState([]);
    const [page, setPage] = useState(1);
    const [isEndOfResults, setIsEndOfResults] = useState(false);
    const [isLoadingResults, setIsLoadingResults] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showShareUrlPopup, setShowShareUrlPopup] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const resultLimit = 10;
    const { user } = props.auth;

    const shareCopy = 'To add someone to your Player group click the share button and send the link to anyone you know. When they click the link they will be added to your Player Group after signing in. You can also share an event link when using the "Create Play" feature and they will be added to your Player Group when they confirm.';
    const shareModalTitle = 'Add Player to your Group';
    const shareModalSubtitle = 'To add someone to your Player Group share this link to anyone you know.  When they click the link they will be aded to your Player Group after signing in.';
    const shareModalInputLabel = 'Player Group Link';
    const axiosInstance = getApiAxiosInstance();

    const getGroupMembers = async () => {
        setIsLoadingResults(true);
        const response = await getMyGroupMembers(axiosInstance, page, resultLimit);
        setIsLoadingResults(false);

        if (response.data.error) {
            props.showErrorPopup({
                message: 'Error loading My Player Group',
            });
        } else if (response.data) {
            const { results } = response.data;

            if (results.length < resultLimit) {
                setIsEndOfResults(true);
            }
            setMemberResults([...memberResults, ...results]);
            setPage(page + 1);
        }
    };

    useEffect(() => {
        getGroupMembers();
    }, []);

    const handleOnLoadMoreClicked = () => {
        getGroupMembers();
    };

    const handleOnAddPlayerClicked = async () => {
        setIsLoading(true);
        const playerId = user?.claimedPlayer.playerId;
        const response = await getAddMemberShareLink(axiosInstance, playerId);

        if (response.data.error) {
            setIsLoading(false);
            props.showErrorPopup({
                message: 'Error adding player',
            });
        } else if (response.data) {
            const { link } = response.data;
            setIsLoading(false);
            setShowShareUrlPopup(true);
            setShareUrl(link);
        }
    };

    const handleOnRequestCloseShareModal = () => {
        setShowShareUrlPopup(false);
    };

    return (
        <div className={styles.playerGroups}>
            <div className={`container`}>
                <div className={`row`}>
                    <div className={`col-12`}>
                        <div className={styles.titleContainer}>
                            <div className="text-callout text-black" data-testid="my-groups.page.title">My Player Group</div>
                        </div>
                    </div>
                    <div className={`col-12`}>
                        <div className={'mt48'} data-testid="my-groups.page.share-description">{shareCopy}</div>
                        <div className={'flex-start mt40'}>
                            <button
                                onClick={handleOnAddPlayerClicked}
                                type="button"
                                className={`btn btn-primary text-uppercase`}
                                data-testid="my-groups.page.add-player-btn"
                            >
                                {isLoading ? 'Loading...' : 'Share'}
                            </button>
                        </div>

                    </div>
                </div>
                <PlayersListSortable players={memberResults} />
                {!isEndOfResults && (
                    <div className={'flex-center mt40'}>
                        <button
                            type="button"
                            className={'btn btn-primary uppercase'}
                            onClick={handleOnLoadMoreClicked}
                            data-testid="my-groups.page.load-more-btn"
                        >
                            {isLoadingResults ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}
                {showShareUrlPopup && (
                    <ShareUrlPopupNew
                        title={shareModalTitle}
                        subtitle={shareModalSubtitle}
                        text={shareModalInputLabel}
                        url={shareUrl}
                        hideButton={true}
                        isDraft={false}
                        onCloseClick={handleOnRequestCloseShareModal}
                    />
                )}
            </div>
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        showErrorPopup: (data) => dispatch(showErrorPopup(data)),
    };
}

function mapStateToProps({ auth, playerGroups }) {
    return { auth, playerGroups };
}

MyGroupsPage.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
    showErrorPopup: PropTypes.func.isRequired,
};
export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(MyGroupsPage));
